import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ReportBuilderService } from '@app/main/report/services/report-builder.service';
import { ReportGetter } from '@app/main/report/directives/ReportGetter';
import { MatDialog } from '@angular/material/dialog';
import { FileService } from '@shared/services/file.service';
import { Router } from '@angular/router';
import { NavigationService } from '@shared/services/navigation.service';
import { DialogService, GuardService, SnackService } from '@shared/services';
import { ModuleService } from '@shared/services/module.service';

@Component({
    selector: 'app-report-released',
    templateUrl: './report-released.component.html',
    styleUrls: ['./report-released.component.scss'],
    standalone: false
})
export class ReportReleasedComponent extends ReportGetter {
    @Input() disableButtons: boolean;
    @Output() saveEmitter = new EventEmitter<string>();

    constructor(
        private fileService: FileService,
        private dialogService: DialogService,
        private snack: SnackService,
        builder: ReportBuilderService,
        dialog: MatDialog,
        router: Router,
        navigation: NavigationService,
        guard: GuardService,
        moduleService: ModuleService
    ) {
        super(builder, dialog, router, navigation, guard, moduleService);
    }

    public async export() {
        this.disableButtons = true;
        if (this.reportService.hasEmbeddedImages(this.report)) {
            this.dialogService
                .openDialog({
                    title: 'Export',
                    message: this.translateService.instant('report.actions.exportWithImage'),
                    confirmText: 'Continue'
                })
                .subscribe(async e => {
                    if (e && e.checked) {
                        try {
                            await this.fileService.exportReport(this.report);
                        } catch (error) {
                            this.snack.openSnackBarError('An error has occurred!');
                        }
                    }
                });
        } else {
            try {
                await this.fileService.exportReport(this.report);
            } catch (error) {
                this.snack.openSnackBarError('An error has occurred!');
            }
        }
        this.disableButtons = false;
    }

    async upload(file: File) {
        if (file) {
            if (file.type !== 'application/pdf') {
                this.snack.openSnackBarError('An error has occurred!');
                return;
            }

            this.dialogService
                .openDialog({
                    title: 'Upload',
                    message: `Are you sure you want to upload the following file?<br/><br/><b>${file.name}</b>`,
                    confirmText: 'Upload'
                })
                .subscribe(async e => {
                    if (e && e.checked) {
                        await this.reportService.uploadManualReport(this.report, file);
                        const report = await this.reportService.uploadManual(this.report);

                        this.snack.openSnackBarSuccess('Success');
                        this.goBack();
                    }
                });
        }
    }
}
